<script>
    import {HorizontalBar, mixins} from 'vue-chartjs'
    import ChartJsPluginDataLabels from 'chartjs-plugin-labels';

    const {reactiveProp} = mixins

    export default {
        extends: HorizontalBar,
        mixins: [reactiveProp],
        components: {
            ChartJsPluginDataLabels
        },
        props: {
            chartData: {
                type: Object,
                default: null
            }
        },
        mounted() {
            this.renderChart(this.chartData, {
                maintainAspectRatio: false,
                responsive: true,
                legend: {
                    display: false
                },
                // title: {
                //     display: false,
                //     text: ''
                // },
                plugins: {
                    labels: {
                        render: 'value',
                        fontColor: 'white'
                    }
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    yAxes: [{
                        // barPercentage: 1.5,
                        // barThickness: 50,
                        // maxBarThickness: 50,
                        minBarLength: 1,
                        gridLines: {
                            offsetGridLines: true
                        }
                    }]
                }
            })
        }
    }
</script>

